export const routes = [
  {
    path: '/customers',
    /* internal name: '/customers' */
    /* no component */
    children: [
      {
        path: '',
        name: '/customers/',
        component: () => import('/home/runner/_work/configuration-app/configuration-app/src/pages/customers/index.vue'),
        /* no children */
      },
      {
        path: ':shortName',
        name: '/customers/[shortName]',
        component: () => import('/home/runner/_work/configuration-app/configuration-app/src/pages/customers/[shortName].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/incidents',
    /* internal name: '/incidents' */
    /* no component */
    children: [
      {
        path: '',
        name: '/incidents/',
        component: () => import('/home/runner/_work/configuration-app/configuration-app/src/pages/incidents/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/parameters',
    /* internal name: '/parameters' */
    /* no component */
    children: [
      {
        path: '',
        name: '/parameters/',
        component: () => import('/home/runner/_work/configuration-app/configuration-app/src/pages/parameters/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/schema-playground',
    /* internal name: '/schema-playground' */
    /* no component */
    children: [
      {
        path: '',
        name: '/schema-playground/',
        component: () => import('/home/runner/_work/configuration-app/configuration-app/src/pages/schema-playground/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/services',
    /* internal name: '/services' */
    /* no component */
    children: [
      {
        path: '',
        name: '/services/',
        component: () => import('/home/runner/_work/configuration-app/configuration-app/src/pages/services/index.vue'),
        /* no children */
      }
    ],
  }
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

